// Голос в опросе «Кто победит?» (блок who_wins матча и главной) — при выключенной игре (HQ-1572) вместо игры.
// POST vote_path {team_id} как есть; ответ — авторитетное состояние опроса (options, my_vote), им заменяем блок.
// reason sign_in / closed — голос не принят: карточка без кнопок, без тоста.
import { useMutation } from '@tanstack/react-query';
import { ApiError, apiRequest } from './client';
import type { WhoWinsBlock, WhoWinsPoll } from './matchTypes';

/** Отказ, после которого кнопки убираем: войти нужно или опрос закрыт. */
export const VOTE_LOCK_REASONS = ['sign_in', 'closed'];

export type VoteResult = Partial<WhoWinsPoll>;

/** Причина отказа из ответа (200 с reason) или из ошибки (код/тело 4xx); иначе null. */
export function voteLockReason(result: unknown): string | null {
  const reason = result instanceof ApiError
    ? (result.payload?.reason as string | undefined) ?? result.code
    : (result as VoteResult | undefined)?.reason;
  return reason && VOTE_LOCK_REASONS.includes(reason) ? reason : null;
}

/** POST vote_path {team_id} с Bearer (гостевая сессия подходит; без неё сервер ответит reason sign_in). */
export function postVote(path: string, teamId: number): Promise<VoteResult> {
  return apiRequest<VoteResult>('POST', path, { auth: true, body: { team_id: teamId } });
}

/** Исход голоса для карточки: отказ sign_in / closed — блок прежний, кнопки убрать; иначе ответ заменяет блок. */
export function applyVote(block: WhoWinsBlock, result: unknown): { block: WhoWinsBlock; locked: boolean } {
  if (voteLockReason(result)) return { block, locked: true };
  if (result instanceof Error || !result || typeof result !== 'object') return { block, locked: false };
  return { block: { ...block, ...(result as VoteResult) }, locked: false };
}

export function useWhoWinsVote(path: string | undefined) {
  return useMutation({ mutationFn: (teamId: number) => postVote(path!, teamId) });
}
